import { Component, inject, Input, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoadControlsForm } from './road-controls.form';
import { ExposedMapDictionary, ExposedMapDictRoad } from '../../../../../../common/exposed-map/exposed-map.component';

@Component({
  selector: 'app-road-controls-set',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ReactiveFormsModule
  ],
  templateUrl: './road-controls-set.component.html'
})
export class RoadControlsSetComponent {

  @Input()
  public hideStreetControl = false;

  private defaultRoadDict$: Observable<{
    roadName: string;
    roadNumber: string;
    sourceId: number
  }[]> = inject(HttpClient).get<any>('drogi_numer_nazwa.json');

  public defaultRoadDict: Signal<{
    roadName: string;
    roadNumber: string;
    sourceId: number
  }[] | undefined> = toSignal(this.defaultRoadDict$);

  @Input()
  public form: RoadControlsForm | undefined;

  @Input()
  set expMapDict(data: ExposedMapDictionary | undefined) {
    const road: ExposedMapDictRoad | null = data?.roads.at(0) || null;
    if (road) {
      this.form?.roadNumber?.setValue(road?.roadNo);
      this.roadNumberChange(road?.roadNo || '');
      this.form?.roadName?.setValue(road?.roadName);
      this.form?.street?.setValue(road?.street || '');
    }
  }

  public roadNumberChange(value: string): void {
    const selected = this.defaultRoadDict()?.filter(v => v.roadNumber === value).at(0);
    this.form?.roadName.setValue(selected?.roadName || '');
  }
}
